import React, { useEffect,useState } from 'react';
import { useNavigate } from 'react-router-dom';  // Correct import for useNavigate
import Button from 'react-bootstrap/Button';
function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);  // State for loading spinner
  const navigate = useNavigate();  // Replacing useHistory with useNavigate
  const authToken = localStorage.getItem('authToken');
  
 useEffect(() => {
      // If there is no authToken, redirect the user to SignIn page
      if (!authToken) {
        navigate('/');
      }else{
        // navigate('/dashboard');
        navigate('/nc');
        // navigate('/points');
      }
    }, [authToken, navigate]);
// Handle email change
const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError('');  // Reset error message when user types again
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);  // Start loading

    // Validate email, phone number, and country code
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      setLoading(false);  // Stop loading
      return;
    }
    // Base64 encode the password
    const encodePassword = (password) => {
      return btoa(password);  // Base64 encoding
    };
    const encodedPassword = encodePassword(password);
    // Simulate OTP request API call (Replace with actual API in production)
    try {
     // const response = await fetch('https://beta.flowlogic.com/api/users/otp-request/', {
      const response = await fetch('https://beta.flowlogic.com/api/users/auth/login/', {
      // const response = await fetch('http://192.168.10.167:8000/api/users/auth/login/', {

      // const response = await fetch('https://4ad0e8a691b5.ngrok-free.app/api/users/auth/login/', {
       
      // const response = await fetch('http://192.168.10.167:8000/api/users/auth/login/', {
        // const response = await fetch('https://flowmap.uvjtech.in/api/users/auth/login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password: encodedPassword }),  // Send all three parameters
      });

      const data = await response.json();  // Parse JSON response
        // Log the response data for debugging
        console.log('Response data:', data);
        
        // console.log('otp', data.data.otp);
      if (response.ok) {
        const emailVerified = data.data.email_verified;
        // const isSubscribed = data.data.is_subscribed; 
        const isSubscribed =true; 
        const usernamefirst = data.data.first_name;
        const usernamelast = data.data.last_name;
        // Get first letters, uppercase for aesthetics
const initials =
  (usernamefirst?.charAt(0) || '').toUpperCase() +
  (usernamelast?.charAt(0) || '').toUpperCase();

       // if (emailVerified) { 
          localStorage.setItem('email', email);
        // if (emailVerified) 
        //   {
             localStorage.setItem('email', email);
          localStorage.setItem('authToken', data.data.token.access);
           localStorage.setItem('refreshToken', data.data.refresh);
           localStorage.setItem('isSubscribed', isSubscribed); 
         localStorage.setItem('name', initials);
          // localStorage.setItem('eula_accepted', data.eula_accepted);
          // console.log('eula_accepted login', data.eula_accepted);
          localStorage.setItem('eula_accepted', data.data.eula_accepted);
console.log('eula_accepted login', data.data.eula_accepted);
           navigate('/dashboard');
          //  navigate('/points');
           // } else {
            //navigate('/otp'); 
          //}

      //  emailVerified?? localStorage.setItem('email', email);  // Store email for later use
      //  emailVerified??  localStorage.setItem('authToken', data.data.token.access);  // Store the access token
      // //  emailVerified?? console.log('Access Token:', data.data.token.access);
      //  emailVerified?? localStorage.setItem('refreshToken', data.data.refresh); 
      
          //   // (data.data.email_verified === true)? navigate('/dashboard'): navigate('/otp');
       
      //   emailVerified ? navigate('/dashboard') : navigate('/otp');
       
      }
      // if (response.status === 401 && data.data && data.data.verify_email === true) {
      //   // Redirect to the OTP page if the email is not verified.
      //   navigate('/otp');
      // } 
      else {
        // If the API returns an error
        setError(data.message || 'Something went wrong, please try again.');
      }
    } catch (err) {
      console.error('Failed to parse JSON:', err);
      setError('Network error, please try again later.');
    }

    setLoading(false);  // Stop loading after request is complete
  };

  return (
    <div className="signMainInOuter">
    <div className="signInOuter">
    <div className="logo"><img src={"/assets/Flowlogic-Logo.svg"} alt="FlowLogic Icon"  /></div>
      <h4>Sign In</h4>
      <form onSubmit={handleSubmit}>
        {/* <input
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={handleEmailChange}
          required
        /> */}
        <div className="form-group">
            <label for="exampleInputEmail1">Email address:</label>
            <input
                type="email"
                className="form-control" 
                placeholder="Enter email"
                value={email}lass="form-control" 
                onChange={handleEmailChange}
                required
                />
            
            
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter Password"
            required
          />
        </div>
        <Button  variant="success" type="submit" disabled={loading}>
          {loading ? 'Sign In...' : 'Sign In'}
        </Button >
      </form>

      {/* Show error message */}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div className="SignInLink">
        {/* Don't have an account yet? <a href='/register'>Sign Up</a><br /> */}
      <a href="/forgot-passord-request">Forgot Password?</a>
      </div>
        </div>
    </div>
  );
}

export default SignIn;
